/* eslint-disable no-unused-vars */
import React from 'react';

import {
  Modal,
  ModalContent,
  ModalOverlay,
  useToast,
  Spinner,
} from '@chakra-ui/react';
import { useQuery } from 'react-query';
import {
  Route as RouteDom,
} from 'react-router-dom';

import { getLoggedUser } from 'api/auth';
import useUser from 'stores/useUser';

import { Redirect } from './redirect';

export function Route({
  children,
  exact,
  path,
  isSafeRoute,
}: {
  children: JSX.Element,
  exact?: boolean,
  path?: string,
  isSafeRoute?: boolean
}) {
  const { token, user, setUser } = useUser();
  const toast = useToast();
  const { isFetching } = useQuery(['logged', 'user', token], () => getLoggedUser(), {
    cacheTime: 0,
    refetchInterval: 60000,
    enabled: !!token && !user,
    onSuccess: (response) => {
      setUser(response?.data);
    },
  });

  if (isFetching) {
    return (
      <Modal
        isOpen={isFetching}
        onClose={() => {
          toast({
            title: 'Aguarde um momento.',
            description: 'Estamos carregando as informações',
            status: 'info',
            duration: 2000,
            position: 'top-right',
            isClosable: true,
          });
        }}>
        <ModalOverlay />
        <ModalContent
          alignSelf="center"
          bg="transparent"
          alignItems="center"
          shadow="none">
          <Spinner
            color="primary.default"
            thickness="4px"
            size="xl"
          />
        </ModalContent>
      </Modal>
    );
  }

  if (!isSafeRoute) {
    return (
      <RouteDom
        exact={Boolean(exact)}
        path={path || null}>
        {children}
      </RouteDom>
    );
  }

  return (
    <RouteDom
      exact={Boolean(exact)}
      path={path || null}
      render={({ location }) => (token ? (
        children
      ) : (
        <Redirect
          to={{
            pathname: '/login',
            state: { from: location.pathname },
          }}
        />
      ))}
    />
  );
}
